const ShowOutboxTypes = {
  SHOW_OUTBOX: "SHOW_OUTBOX",
  REMOVE_LAST_SENT: "REMOVE_LAST_SENT",
};

export default ShowOutboxTypes;
